import { Hidden } from "@material-ui/core";
import React from "react";
import { SearchBar } from "../../widgets/searchView/searchComponent";

function HiddenSearchBar(props) {
  const {
    value, check, placeHolder, handleSearchChange, hiddenFor, classes,
  } = props;
  return (
    <Hidden only={hiddenFor}>
      <div className={classes}>
        {check ? (
          value
          && value === check && (
            <SearchBar
              placeHolder={placeHolder}
              onSearchChange={(e) => {
                handleSearchChange(e);
              }}
            />
          )
        ) : (
          <SearchBar
            placeHolder={placeHolder}
            onSearchChange={(e) => {
              handleSearchChange(e);
            }}
          />
        )}
      </div>
    </Hidden>
  );
}

export default HiddenSearchBar;
